import { Assert } from '@team/assert';

export function getWindow(node: unknown): typeof window {
  if (!Assert.isNodeInstance(node)) {
    return window;
  }

  if (
    Assert.isUndefined(node.ownerDocument) ||
    Assert.isNull(node.ownerDocument)
  ) {
    return window;
  }

  if (
    Assert.isUndefined(node.ownerDocument.defaultView) ||
    Assert.isNull(node.ownerDocument.defaultView)
  ) {
    return window;
  }

  return node.ownerDocument.defaultView;
}
